module.exports = __webpack_public_path__ + "445b5b34f2056eb531cf1109fa948f32.svg";